import { useState } from "react";
import axios from "axios";

const SubirOfertasXML = () => {
  const [file, setFile] = useState(null);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!file) {
      setError("Debes seleccionar un archivo XML.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/ofertas/xml`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setMensaje(res.data.message || "Archivo subido correctamente.");
      setError("");
    } catch (err) {
      setError(err.response?.data?.detail || "Error al subir el archivo.");
      setMensaje("");
    }
  };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "40px auto",
        padding: 30,
        borderRadius: 12,
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
        textAlign: "center",
        fontFamily: "Arial, sans-serif"
      }}
    >
      <h2 style={{ marginBottom: 20 }}>Subir Ofertas </h2>
      <input
        type="file"
        accept=".xml"
        onChange={handleFileChange}
        style={{ marginBottom: 15, fontSize: "0.9em", display: "block", width: "100%" }}
      />
      <button
        onClick={handleSubmit}
        style={{
          backgroundColor: "#007B8F",
          color: "white",
          border: "none",
          padding: "10px 20px",
          borderRadius: 6,
          display: "block",
          width: "100%",
          cursor: "pointer",
          fontSize: "0.9em",
          fontWeight: "bold"
        }}
      >
        Subir XML
      </button>
      {mensaje && <p style={{ color: "green", marginTop: 15 }}>{mensaje}</p>}
      {error && <p style={{ color: "red", marginTop: 15 }}>{error}</p>}
    </div>
  );
};

export default SubirOfertasXML;